/**
 * Formattazione unica prezzi/date (design system upgrade 2026).
 */

const priceFmt = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR'
});

const dayLongFmt = new Intl.DateTimeFormat('it-IT', {
  weekday: 'long',
  day: 'numeric'
});

const dayShortFmt = new Intl.DateTimeFormat('it-IT', {
  weekday: 'short',
  day: 'numeric'
});

const dateLongFmt = new Intl.DateTimeFormat('it-IT', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric'
});

function toDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Es. `120,00 €` oppure `Gratuita` se 0. */
export function formatPrice(value) {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  if (n <= 0) return 'Gratuita';
  return priceFmt.format(n);
}

/** Es. `da 120,00 €` oppure `Gratuita` (mai `da Gratuita`). */
export function formatPriceFrom(value) {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  if (n <= 0) return 'Gratuita';
  return `da ${priceFmt.format(n)}`;
}

/** Es. `lunedì 19 ottobre 2026`. */
export function formatDateLong(value) {
  const d = toDate(value);
  return d ? dateLongFmt.format(d) : '';
}

/** Es. `lun 19` per selettori giorno. */
export function formatDayShort(value) {
  const d = toDate(value);
  if (!d) return '';
  return dayShortFmt.format(d).replace('.', '');
}

/** Es. `Lunedì 19` (titoli). */
export function formatDayLong(value) {
  const d = toDate(value);
  if (!d) return '';
  const s = dayLongFmt.format(d);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Alias legacy. */
export const formatDate = formatDateLong;
